<template>
<div class="icon-select">	
	<el-popover :width="480" trigger="click" popper-class="icon-select__popover">
		<template #reference>
			<el-input v-bind="config" :model-value="modelValue" @input="handleInput">
				<template #suffix>
					<el-icon><component :is="modelValue"></component></el-icon>
				</template>
			</el-input>
		</template>
		<el-tabs v-model="currentTab">
			<el-tab-pane name="system" label="系统">
				<el-scrollbar style="height: 300px"> 
					<div class="icon-list">
						<template :span="3" v-for="(icon, index) in iconNameList" :key="index">
							<div class="icon-item d-flex d-flex-align-items-center d-flex-justify-content-center" @click="handleIconClick(icon)">
								<el-icon size="large"><component :is="icon"></component></el-icon>
							</div>
						</template>
					</div>
				</el-scrollbar>
			</el-tab-pane>
			<el-tab-pane name="custom" label="自定义">
				<el-scrollbar style="height: 300px">
					<div class="icon-list">
						<template :span="3" v-for="(icon, index) in customIconNameList" :key="index">
							<div class="icon-item d-flex d-flex-align-items-center d-flex-justify-content-center" @click="handleIconClick(icon)">
								<el-icon size="large"><component :is="icon"></component></el-icon>
							</div>
						</template>
					</div>
				</el-scrollbar>
			</el-tab-pane>
		</el-tabs>
	</el-popover>
</div>
</template>

<script setup>
	const props = defineProps({
		modelValue: { type: String },
		config: { type: Object, default: ()=>({}) }, 
	})
	 
	const emits = defineEmits(['update:modelValue'])
	
	const currentTab = ref('system')
	
	const handleInput = (v) => {
		emits('update:modelValue', v)
	}
	
	const handleIconClick = (icon) => {
		emits('update:modelValue', icon)
	}
</script>

<style lang="scss" scoped>
	.icon-select { 
		width: 100%; 
	}
	
	.icon-select__popover {
		.icon-list {
			display: grid;
			grid-template-columns: repeat(8, 1fr);
			
			.icon-item {
				height: 48px;
				width: 48px;
				
				&:hover {
					background-color: var(--vt-c-white-soft);
					cursor: pointer;
				}
			}
		}
	}
</style>